var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecapPinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.79,
    height: 27.246,
    viewBox: "0 0 18.79 27.246",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_4267",
    "data-name": "Rettangolo 4267",
    width: 18.79,
    height: 27.246,
    transform: "translate(0 -0.001)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_13200",
    "data-name": "Raggruppa 13200",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_13199",
    "data-name": "Raggruppa 13199",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_21602",
    "data-name": "Tracciato 21602",
    d: "M16.645,13.774,9.4,25.366,2.145,13.774l0,0a8.629,8.629,0,0,1-.522-1.023,8.456,8.456,0,1,1,15.026,1.026Z",
    fill: "none",
    stroke: "#951a33",
    strokeWidth: 1.879
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_21603",
    "data-name": "Tracciato 21603",
    d: "M9.4,14.092A4.7,4.7,0,1,0,4.7,9.4,4.7,4.7,0,0,0,9.4,14.092Z",
    fill: "none",
    stroke: "#951a33",
    strokeWidth: 1.879
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecapPinIcon);
export default __webpack_public_path__ + "static/media/recap-pin-icon.0ea9e5a29430f32a54faaa7218f40dd9.svg";
export { ForwardRef as ReactComponent };